import api from './api';
import { Abwesenheit, CreateAbwesenheitDTO, AppType } from '../types';
import { toDateKey } from '../utils/dateUtils';

export const abwesenheitService = {
    getAllAbwesenheiten: async (params?: { startDatum?: Date; endDatum?: Date; arztId?: number; app?: AppType }) => {
        const queryParams: any = {};

        if (params?.startDatum) {
            queryParams.startDatum = toDateKey(params.startDatum);
        }

        if (params?.endDatum) {
            queryParams.endDatum = toDateKey(params.endDatum);
        }

        if (params?.arztId) {
            queryParams.arztId = params.arztId;
        }

        if (params?.app) {
            queryParams.app = params.app;
        }

        const response = await api.get<Abwesenheit[]>('/abwesenheiten', {
            params: queryParams,
        });
        return response.data;
    },

    createAbwesenheit: async (data: CreateAbwesenheitDTO) => {
        const response = await api.post<Abwesenheit>('/abwesenheiten', data);
        return response.data;
    },

    deleteAbwesenheit: async (id: number) => {
        const response = await api.delete(`/abwesenheiten/${id}`);
        return response.data;
    },
};
